module.exports = __webpack_public_path__ + "img/frenteBus.49325c93.svg";